import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';

export function registerSelectLocationDialogResourceBundleDe(
  i18next: i18n
): void {
  i18next.addResourceBundle(
    'de',
    'record-it-components',
    {
      location: {
        SelectLocationDialog: {
          cancel: 'Abbrechen',
          latitude: 'Breitengrad',
          longitude: 'Längengrad',
          title: 'Koordinaten auswählen'
        }
      }
    } as Partial<CustomTypeOptions['resources']['record-it-components']>,
    true
  );
}
